import { useTranslation } from 'react-i18next';

interface PropTypes {
  t: (e:string) => string
}

export function tabMainGroup({ t }: PropTypes) {
  const dataTab = [
    {
      value: 1,
      label: t('company.competency_skillGroup'),
    },
    {
      value: 2,
      label: t('side_bar.organization'),
    },
    {
      value: 3,
      label: 'WLA',
    },
    {
      value: 4,
      label: t('side_bar.job_desc'),
    },
    {
      value: 5,
      label: t('board.member'),
    },
  ];
  return dataTab;
}

export function TabCompetency() {
  const { t } = useTranslation();
  const Array = [];

  const typeTab = (val: number) => {
    switch (val) {
      case 1:
        return t('company.skill_group');
      case 2:
        return t('company.competency_library');

      default:
        return '';
    }
  };

  for (let index = 1; index <= 2; index += 1) {
    const Data = { id: index, name: typeTab(index) };
    Array.push(Data);
  }

  return Array;
}
export function TabOrganization(isBoardList: boolean) {
  const { t } = useTranslation();

  const allTabs = [
    { id: 1, label: t('org.index_view.import.directorate') },
    { id: 2, label: t('org.index_view.form.job_lvl') },
    { id: 3, label: t('wla.analytics.table.region') },
    { id: 4, label: t('company.custom_parameter') },
  ];

  const filteredTabs = isBoardList
    ? allTabs.filter((tab) => tab.id !== 2)
    : allTabs;

  return filteredTabs.map((item, index) => ({
    id: index + 1,
    value: item.id,
    name: item.label,
  }));
}

export function TabWLA() {
  const { t } = useTranslation();
  const Array = [];

  const typeTab = (val: number) => {
    switch (val) {
      case 1:
        return t('workload_landing.custom_category');
      case 2:
        return t('company.wla_category');
      case 3:
        return t('workload_landing.type_activity');
      case 4:
        return t('company.fte_limit');
      case 5:
        return t('org.structure_view.worker_type_name');

      default:
        return '';
    }
  };

  for (let index = 1; index <= 5; index += 1) {
    const Data = { id: index, name: typeTab(index) };
    Array.push(Data);
  }

  return Array;
}
